module.exports = __webpack_public_path__ + "imgs/person.bbc8d4e11d42fe23cf36fbe59aabf987.svg";